import { render, staticRenderFns } from "./DriverDashboard.vue?vue&type=template&id=feef02b8"
import script from "./DriverDashboard.vue?vue&type=script&lang=js"
export * from "./DriverDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports